/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchRouteImport } from './routes/search'
import { Route as CoursesRouteImport } from './routes/courses'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TopIndexRouteImport } from './routes/top/index'
import { Route as RandomIndexRouteImport } from './routes/random/index'
import { Route as FaqIndexRouteImport } from './routes/faq/index'
import { Route as TopSlugRouteImport } from './routes/top/$slug'
import { Route as RandomInstructorRouteImport } from './routes/random/instructor'
import { Route as RandomCourseRouteImport } from './routes/random/course'
import { Route as IInstructorNameRouteImport } from './routes/i/$instructorName'
import { Route as GGroupIdRouteImport } from './routes/g/$groupId'
import { Route as FaqSlugRouteImport } from './routes/faq/$slug'
import { Route as CCourseNameRouteImport } from './routes/c/$courseName'

const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesRoute = CoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TopIndexRoute = TopIndexRouteImport.update({
  id: '/top/',
  path: '/top/',
  getParentRoute: () => rootRouteImport,
} as any)
const RandomIndexRoute = RandomIndexRouteImport.update({
  id: '/random/',
  path: '/random/',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqIndexRoute = FaqIndexRouteImport.update({
  id: '/faq/',
  path: '/faq/',
  getParentRoute: () => rootRouteImport,
} as any)
const TopSlugRoute = TopSlugRouteImport.update({
  id: '/top/$slug',
  path: '/top/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const RandomInstructorRoute = RandomInstructorRouteImport.update({
  id: '/random/instructor',
  path: '/random/instructor',
  getParentRoute: () => rootRouteImport,
} as any)
const RandomCourseRoute = RandomCourseRouteImport.update({
  id: '/random/course',
  path: '/random/course',
  getParentRoute: () => rootRouteImport,
} as any)
const IInstructorNameRoute = IInstructorNameRouteImport.update({
  id: '/i/$instructorName',
  path: '/i/$instructorName',
  getParentRoute: () => rootRouteImport,
} as any)
const GGroupIdRoute = GGroupIdRouteImport.update({
  id: '/g/$groupId',
  path: '/g/$groupId',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqSlugRoute = FaqSlugRouteImport.update({
  id: '/faq/$slug',
  path: '/faq/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CCourseNameRoute = CCourseNameRouteImport.update({
  id: '/c/$courseName',
  path: '/c/$courseName',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/courses': typeof CoursesRoute
  '/search': typeof SearchRoute
  '/c/$courseName': typeof CCourseNameRoute
  '/faq/$slug': typeof FaqSlugRoute
  '/g/$groupId': typeof GGroupIdRoute
  '/i/$instructorName': typeof IInstructorNameRoute
  '/random/course': typeof RandomCourseRoute
  '/random/instructor': typeof RandomInstructorRoute
  '/top/$slug': typeof TopSlugRoute
  '/faq/': typeof FaqIndexRoute
  '/random/': typeof RandomIndexRoute
  '/top/': typeof TopIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/courses': typeof CoursesRoute
  '/search': typeof SearchRoute
  '/c/$courseName': typeof CCourseNameRoute
  '/faq/$slug': typeof FaqSlugRoute
  '/g/$groupId': typeof GGroupIdRoute
  '/i/$instructorName': typeof IInstructorNameRoute
  '/random/course': typeof RandomCourseRoute
  '/random/instructor': typeof RandomInstructorRoute
  '/top/$slug': typeof TopSlugRoute
  '/faq': typeof FaqIndexRoute
  '/random': typeof RandomIndexRoute
  '/top': typeof TopIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/courses': typeof CoursesRoute
  '/search': typeof SearchRoute
  '/c/$courseName': typeof CCourseNameRoute
  '/faq/$slug': typeof FaqSlugRoute
  '/g/$groupId': typeof GGroupIdRoute
  '/i/$instructorName': typeof IInstructorNameRoute
  '/random/course': typeof RandomCourseRoute
  '/random/instructor': typeof RandomInstructorRoute
  '/top/$slug': typeof TopSlugRoute
  '/faq/': typeof FaqIndexRoute
  '/random/': typeof RandomIndexRoute
  '/top/': typeof TopIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/courses'
    | '/search'
    | '/c/$courseName'
    | '/faq/$slug'
    | '/g/$groupId'
    | '/i/$instructorName'
    | '/random/course'
    | '/random/instructor'
    | '/top/$slug'
    | '/faq/'
    | '/random/'
    | '/top/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/courses'
    | '/search'
    | '/c/$courseName'
    | '/faq/$slug'
    | '/g/$groupId'
    | '/i/$instructorName'
    | '/random/course'
    | '/random/instructor'
    | '/top/$slug'
    | '/faq'
    | '/random'
    | '/top'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/courses'
    | '/search'
    | '/c/$courseName'
    | '/faq/$slug'
    | '/g/$groupId'
    | '/i/$instructorName'
    | '/random/course'
    | '/random/instructor'
    | '/top/$slug'
    | '/faq/'
    | '/random/'
    | '/top/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  CoursesRoute: typeof CoursesRoute
  SearchRoute: typeof SearchRoute
  CCourseNameRoute: typeof CCourseNameRoute
  FaqSlugRoute: typeof FaqSlugRoute
  GGroupIdRoute: typeof GGroupIdRoute
  IInstructorNameRoute: typeof IInstructorNameRoute
  RandomCourseRoute: typeof RandomCourseRoute
  RandomInstructorRoute: typeof RandomInstructorRoute
  TopSlugRoute: typeof TopSlugRoute
  FaqIndexRoute: typeof FaqIndexRoute
  RandomIndexRoute: typeof RandomIndexRoute
  TopIndexRoute: typeof TopIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses': {
      id: '/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof CoursesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/top/': {
      id: '/top/'
      path: '/top'
      fullPath: '/top/'
      preLoaderRoute: typeof TopIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/random/': {
      id: '/random/'
      path: '/random'
      fullPath: '/random/'
      preLoaderRoute: typeof RandomIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/': {
      id: '/faq/'
      path: '/faq'
      fullPath: '/faq/'
      preLoaderRoute: typeof FaqIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/top/$slug': {
      id: '/top/$slug'
      path: '/top/$slug'
      fullPath: '/top/$slug'
      preLoaderRoute: typeof TopSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/random/instructor': {
      id: '/random/instructor'
      path: '/random/instructor'
      fullPath: '/random/instructor'
      preLoaderRoute: typeof RandomInstructorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/random/course': {
      id: '/random/course'
      path: '/random/course'
      fullPath: '/random/course'
      preLoaderRoute: typeof RandomCourseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$instructorName': {
      id: '/i/$instructorName'
      path: '/i/$instructorName'
      fullPath: '/i/$instructorName'
      preLoaderRoute: typeof IInstructorNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/g/$groupId': {
      id: '/g/$groupId'
      path: '/g/$groupId'
      fullPath: '/g/$groupId'
      preLoaderRoute: typeof GGroupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/$slug': {
      id: '/faq/$slug'
      path: '/faq/$slug'
      fullPath: '/faq/$slug'
      preLoaderRoute: typeof FaqSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$courseName': {
      id: '/c/$courseName'
      path: '/c/$courseName'
      fullPath: '/c/$courseName'
      preLoaderRoute: typeof CCourseNameRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  CoursesRoute: CoursesRoute,
  SearchRoute: SearchRoute,
  CCourseNameRoute: CCourseNameRoute,
  FaqSlugRoute: FaqSlugRoute,
  GGroupIdRoute: GGroupIdRoute,
  IInstructorNameRoute: IInstructorNameRoute,
  RandomCourseRoute: RandomCourseRoute,
  RandomInstructorRoute: RandomInstructorRoute,
  TopSlugRoute: TopSlugRoute,
  FaqIndexRoute: FaqIndexRoute,
  RandomIndexRoute: RandomIndexRoute,
  TopIndexRoute: TopIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
